/* eslint-disable */
import getDadosGraficoOrganizacional from './monitoramento/getDadosGraficoOrganizacional';
import getDadosGraficoNetwork from './monitoramento/getDadosGraficoNetwork';
import getDadosResponsabilidadesGraficoNetwork from './monitoramento/getDadosResponsabilidadesGraficoNetwork';
import getDadosGraficosUnidade from './monitoramento/getDadosGraficosUnidade';
import getDadosGraficosGeral from './monitoramento/getDadosGraficosGeral';

import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import Data from '@/modules/data';

const monitoramentoRepository = RepositoryFactory.get('monitoramento');

const state = {
  mapeamento: {
    data: '',
    hora: '',
    naoComportamentos: [],
    responsabilidades: {},
    responsabilidadesConsolidadas: {},
    responsabilidadesValidadas: {},
    competenciasComportamentais: {},
    competenciasComportamentaisConsolidadas: {},
    competenciasTecnicas: {},
    competenciasTecnicasValidadas: {},
    competenciasTecnicasConsolidadas: {},
    unidade: {},
    unidades: [],
    dadosUnidades: [],
    relatorio: {},
    relatorios: {},
    graficosUnidades: {
      organization: {
        dados: [],
        nos: [],
      },
      loaded: false,
    },
    graficosUnidadesHierarquia: {
      network: {
        dados: [],
        nos: [],
      },
    },
    graficosGeral: {
      comportamento: {
        bar: {
          categorias: [],
          dados: [],
        },
        pie: {
          series: [],
          subSeries: [],
        },
      },
      responsabilidade: {
        network: {},
        pie: {
          series: [],
          subSeries: [],
        },
        pie2: {
          series: [],
          subSeries: [],
        },
        pie3: {
          series: [],
          subSeries: [],
        },
      },
      loaded: false,
    },
    graficosUnidade: {
      pie: {
        series: [],
        subSeries: [],
      },
      pie2: {
        series: [],
        subSeries: [],
      },
      pie3: {
        series: [],
        subSeries: [],
      },
      wordCloud: {texto: ''},
      loaded: false,
    },
    loaded: false
  },
  diagnostico: {loaded: false},
  desempenho: {loaded: false},
  perfil: {loaded: false},
};

let retornoGetSubunidades = [];

function getSubunidades(unidade, unidades) {
  retornoGetSubunidades.push(unidade);
  if (unidade && unidade.subunidades.length > 0) {
    unidade.subunidades.forEach(su => getSubunidades(unidades.find(u => u.id === su.id), unidades));
  }
  return retornoGetSubunidades;
}

const actions = {
  loadMonitoramentoMapeamento({commit, rootState}, payload) {
    return new Promise(async (resolve) => {
      await monitoramentoRepository.getDadosUnidades(payload.mapeamento, payload.unidade).then(res => {
        let unidades = res.data.sort(function (a, b) {
          if (a.sigla > b.sigla) {return 1;}
          if (a.sigla < b.sigla) {return -1;}
          return 0;
        });

        commit('SET_UNIDADES_MAPEAMENTO', unidades);

        if (unidades && unidades.length > 0) {
          let unidade = unidades.find(u => u.id === rootState.auth.unidade.id);
          if (!unidade) {
            unidade = unidades[0];
          }
          commit('SET_UNIDADE_MAPEAMENTO', unidade);
          commit('SET_MAPEAMENTO_GRAFICOS_UNIDADES', getDadosGraficoOrganizacional(unidade));
          retornoGetSubunidades = [];
          commit(
            'SET_MAPEAMENTO_GRAFICOS_UNIDADES_HIERARQUIA', getDadosGraficoNetwork(getSubunidades(unidade, unidades))
          );
        } else {
          commit('SET_UNIDADE_MAPEAMENTO', {});
        }
      });

      await monitoramentoRepository.getDadosMapeamento(payload.mapeamento, payload.unidade).then(res => {
        let monitoramento = res.data;

        let data = Data.compare('isValid', {a: monitoramento.data}) ? Data.format(monitoramento.data) : '';
        let hora = monitoramento.hora ? monitoramento.hora : '';
        commit('SET_DATA_MAPEAMENTO', data);
        commit('SET_HORA_MAPEAMENTO', hora);
        commit('SET_RESPONSABILIDADES', monitoramento.responsabilidades);
        commit('SET_RESPONSABILIDADES_VALIDADAS', monitoramento.responsabilidadesValidadas);
        commit('SET_RESPONSABILIDADES_CONSOLIDADAS', monitoramento.responsabilidadesConsolidadas);
        commit('SET_COMPETENCIAS', monitoramento.competenciasComportamentais);
        commit('SET_COMPETENCIAS_CONSOLIDADAS', monitoramento.competenciasComportamentaisConsolidadas);
        commit('SET_COMPETENCIAS_TECNICAS', monitoramento.competenciasTecnicas);
        commit('SET_COMPETENCIAS_TECNICAS_VALIDADAS', monitoramento.competenciasTecnicasValidadas);
        commit('SET_COMPETENCIAS_TECNICAS_CONSOLIDADAS', monitoramento.competenciasTecnicasConsolidadas);
        commit('SET_NAO_COMPORTAMENTOS', monitoramento.naoComportamentos);

        commit('SET_RELATORIOS_MAPEAMENTO', monitoramento.dados);
        if (monitoramento.dados && monitoramento.dados.length > 0) {
          let relatorio = monitoramento.dados.find(d => d.unidade.id === rootState.auth.unidade.id);
          if (!relatorio) {
            relatorio = monitoramento.dados[0];
          }
          commit('SET_RELATORIO_MAPEAMENTO', relatorio);
          commit('SET_DADOS_UNIDADES', monitoramento.dados);
          let dadosComportamentos = [];
          let dadosResponsabilidades = [];

          monitoramento.dados.forEach(r => {
            dadosComportamentos.push({
              y: r.comportamentos.total,
              gosto: r.comportamentos.gosto,
              naoGosto: r.comportamentos.naoGosto,
              ideal: r.comportamentos.ideal,
              unidade: r.unidade.sigla,
            });

            dadosResponsabilidades.push({
              siglaUnidade: r.unidade.sigla,
              cadastradas: r.responsabilidades.total,
              validadas: r.responsabilidadesValidadas.total,
              consolidadas: r.responsabilidadesConsolidadas.total,
            });
          });

          let graficosGeral = getDadosGraficosGeral(monitoramento, dadosComportamentos);
          graficosGeral.responsabilidade.network = getDadosResponsabilidadesGraficoNetwork(
            state.mapeamento.unidades, dadosResponsabilidades
          );

          let graficosUnidade = getDadosGraficosUnidade(relatorio);

          commit('SET_MAPEAMENTO_GRAFICOS_GERAL', graficosGeral);
          commit('SET_MAPEAMENTO_GRAFICOS_UNIDADE', graficosUnidade);
        } else {
          commit('SET_RELATORIO_MAPEAMENTO', {});
        }
      });

      commit('SET_LOADED_MAPEAMENTO', true);
      resolve();
    });
  },
  setUnidadeMapeamento({commit, state}, unidade) {
    commit('SET_UNIDADE_MAPEAMENTO', unidade);
    commit('SET_MAPEAMENTO_GRAFICOS_UNIDADES', getDadosGraficoOrganizacional(unidade));
    retornoGetSubunidades = [];
    commit(
      'SET_MAPEAMENTO_GRAFICOS_UNIDADES_HIERARQUIA',
      getDadosGraficoNetwork(getSubunidades(unidade, state.mapeamento.unidades))
    );

    let relatorio = state.mapeamento.relatorios.find(r => r.unidade.id === unidade.id);

    if (relatorio) {
      commit('SET_RELATORIO_MAPEAMENTO', relatorio);
      commit('SET_MAPEAMENTO_GRAFICOS_UNIDADE', getDadosGraficosUnidade(relatorio));
    }
  },
  setRelatorioMapeamento({commit}, relatorio) {
    commit('SET_RELATORIO_MAPEAMENTO', relatorio);
  },
  setGraficos({commit}, payload) {
    if (payload && payload.tipo && payload.graficos) {
      switch (payload.tipo) {
        case 'UNIDADES':
          commit('SET_MAPEAMENTO_GRAFICOS_UNIDADES', payload.graficos);
          break;
        case 'GERAL':
          commit('SET_MAPEAMENTO_GRAFICOS_GERAL', payload.graficos);
          break;
        case 'UNIDADE':
          commit('SET_MAPEAMENTO_GRAFICOS_UNIDADE', payload.graficos);
          break;
      }
    }
  },
  setLoadedStatus({commit}, payload) {
    return new Promise(async (resolve) => {
      if (payload) {
        switch (payload.modulo) {
          case 'MAPEAMENTO':
            commit('SET_LOADED_MAPEAMENTO', payload.status);
            break;
          case 'DIAGNOSTICO':
            commit('SET_LOADED_DIAGNOSTICO', payload.status);
            break;
          case 'DESEMPENHO':
            commit('SET_LOADED_DESEMPENHO', payload.status);
            break;
          case 'PERFIL':
            commit('SET_LOADED_PERFIL', payload.status);
            break;
        }
      }

      resolve();
    });
  },
};

const getters = {};

const mutations = {
  SET_NAO_COMPORTAMENTOS: (state, naoComportamentos) => {
    state.mapeamento.naoComportamentos = naoComportamentos;
  },
  SET_DADOS_UNIDADES: (state, dados) => {
    state.mapeamento.dadosUnidades = dados;
  },
  SET_DATA_MAPEAMENTO: (state, data) => {
    state.mapeamento.data = data;
  },
  SET_HORA_MAPEAMENTO: (state, hora) => {
    state.mapeamento.hora = hora;
  },
  SET_RESPONSABILIDADES: (state, responsabilidades) => {
    state.mapeamento.responsabilidades = responsabilidades;
  },
  SET_RESPONSABILIDADES_VALIDADAS: (state, responsabilidades) => {
    state.mapeamento.responsabilidadesValidadas = responsabilidades;
  },
  SET_RESPONSABILIDADES_CONSOLIDADAS: (state, responsabilidades) => {
    state.mapeamento.responsabilidadesConsolidadas = responsabilidades;
  },
  SET_COMPETENCIAS: (state, competencias) => {
    state.mapeamento.competenciasComportamentais = competencias;
  },
  SET_COMPETENCIAS_CONSOLIDADAS: (state, competencias) => {
    state.mapeamento.competenciasComportamentaisConsolidadas = competencias;
  },
  SET_COMPETENCIAS_TECNICAS: (state, competencias) => {
    state.mapeamento.competenciasTecnicas = competencias;
  },
  SET_COMPETENCIAS_TECNICAS_VALIDADAS: (state, competencias) => {
    state.mapeamento.competenciasTecnicasValidadas = competencias;
  },
  SET_COMPETENCIAS_TECNICAS_CONSOLIDADAS: (state, competencias) => {
    state.mapeamento.competenciasTecnicasConsolidadas = competencias;
  },
  SET_UNIDADE_MAPEAMENTO: (state, unidade) => {
    state.mapeamento.unidade = unidade;
  },
  SET_UNIDADES_MAPEAMENTO: (state, unidades) => {
    state.mapeamento.unidades = unidades;
  },
  SET_RELATORIO_MAPEAMENTO: (state, relatorio) => {
    state.mapeamento.relatorio = relatorio;
  },
  SET_RELATORIOS_MAPEAMENTO: (state, relatorios) => {
    state.mapeamento.relatorios = relatorios;
  },
  SET_MAPEAMENTO_GRAFICOS_UNIDADES: (state, graficos) => {
    state.mapeamento.graficosUnidades = graficos;
  },
  SET_MAPEAMENTO_GRAFICOS_UNIDADES_HIERARQUIA: (state, graficos) => {
    state.mapeamento.graficosUnidadesHierarquia = graficos;
  },
  SET_MAPEAMENTO_GRAFICOS_GERAL: (state, graficos) => {
    state.mapeamento.graficosGeral = graficos;
  },
  SET_MAPEAMENTO_GRAFICOS_UNIDADE: (state, graficos) => {
    state.mapeamento.graficosUnidade = graficos;
  },
  SET_LOADED_MAPEAMENTO: (state, status) => {
    state.mapeamento.loaded = status;
  },
  SET_LOADED_DIAGNOSTICO: (state, status) => {
    state.diagnostico.loaded = status;
  },
  SET_LOADED_DESEMPENHO: (state, status) => {
    state.desempenho.loaded = status;
  },
  SET_LOADED_PERFIL: (state, status) => {
    state.perfil.loaded = status;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
